import SuperBookingreports from "../SuperAdminBookingReports/SuperBookingreports";
import "./Reports.scss";
import React from "react";
const Reports = () => {
  return <SuperBookingreports />;
};
export default Reports;
